import script from "./RepoActionView.vue?vue&type=script&setup=true&lang=js"
export * from "./RepoActionView.vue?vue&type=script&setup=true&lang=js"

import "./RepoActionView.vue?vue&type=style&index=0&id=371e0e0c&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-371e0e0c"]])

export default __exports__